import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { hideTipsNav } from '../config/ui-flags';

export const tipsAvailabilityGuard: CanActivateFn = () => {
  if (hideTipsNav) {
    inject(Router).navigate(['/dash/burials']);
    return false;
  }
  return true;
};
